<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar class="-not-fixed">
        <ion-button
          slot="end"
          @click="modalController.dismiss()"
          fill="clear"
          size="large"
          ><ion-icon size="large" :icon="closeOutline"></ion-icon
        ></ion-button>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <div class="modal-content ion-padding ion-text-center">
        <!-- <modal-close /> -->
        <roodie fillOuter="#5E58BE" :expression="'happy'" />
        <ion-grid class="u-color-primary">
          <div class="u-medium ion-margin-top u-bold">
            Mit {{ routingText }} teilen?
          </div>
          <div class="u-xxlarge ion-margin-top">
            <img width="130" src="@/assets/img/content/roodie_share.svg" />
          </div>

          <template v-if="routing === 'BetterDoc'">
            <div class="u-small ion-margin-vertical">
              <a href="#" @click.prevent="isCallTimeOpen = !isCallTimeOpen"
                >Haben Sie Wünsche zur Anrufzeit?</a
              >&nbsp;<ion-icon
                :icon="isCallTimeOpen ? caretUp : caretDown"
              ></ion-icon>
            </div>
            <div v-if="isCallTimeOpen">
              <ion-button
                :fill="callDays.includes('Montag') ? 'solid' : 'outline'"
                @click="changeCallDays('Montag')"
                >MONTAG</ion-button
              ><ion-button
                :fill="callDays.includes('Dienstag') ? 'solid' : 'outline'"
                @click="changeCallDays('Dienstag')"
                >DIENSTAG</ion-button
              ><ion-button
                :fill="callDays.includes('Mittwoch') ? 'solid' : 'outline'"
                @click="changeCallDays('Mittwoch')"
                >MITTWOCH</ion-button
              ><ion-button
                :fill="callDays.includes('Donnerstag') ? 'solid' : 'outline'"
                @click="changeCallDays('Donnerstag')"
                >DONNERSTAG</ion-button
              ><ion-button
                :fill="callDays.includes('Freitag') ? 'solid' : 'outline'"
                @click="changeCallDays('Freitag')"
                >FREITAG</ion-button
              >
              <div class="ion-margin-top">
                <ion-button
                  :fill="callTimes.includes('08:00') ? 'solid' : 'outline'"
                  @click="changeCallTimes('08:00')"
                  >08:00</ion-button
                ><ion-button
                  :fill="callTimes.includes('09:00') ? 'solid' : 'outline'"
                  @click="changeCallTimes('09:00')"
                  >09:00</ion-button
                ><ion-button
                  :fill="callTimes.includes('10:00') ? 'solid' : 'outline'"
                  @click="changeCallTimes('10:00')"
                  >10:00</ion-button
                ><ion-button
                  :fill="callTimes.includes('11:00') ? 'solid' : 'outline'"
                  @click="changeCallTimes('11:00')"
                  >11:00</ion-button
                ><ion-button
                  :fill="callTimes.includes('12:00') ? 'solid' : 'outline'"
                  @click="changeCallTimes('12:00')"
                  >12:00</ion-button
                ><ion-button
                  :fill="callTimes.includes('13:00') ? 'solid' : 'outline'"
                  @click="changeCallTimes('13:00')"
                  >13:00</ion-button
                ><ion-button
                  :fill="callTimes.includes('14:00') ? 'solid' : 'outline'"
                  @click="changeCallTimes('14:00')"
                  >14:00</ion-button
                >
              </div>
            </div>
          </template>

          <div v-if="routing" class="ion-margin-top">
            <component
              :is="
                ['BetterDoc', 'Quality Smile'].includes(routing) ||
                routing.startsWith('ARAG Case Management')
                  ? 'PrivacyBetterDoc'
                  : 'Privacy' + routing.replaceAll(' ', '')
              "
              :routing="routing"
              :routingText="routingText"
              @privacy-roodie-checked="isPrivacyRoodieChecked = $event"
              @checked="
                isPrivacyChecked = true;
                privacy1Label = $event?.privacy1Label;
                privacy2Label = $event?.privacy2Label;
              "
              @unchecked="isPrivacyChecked = false"
              @should-save-checked="shouldSave = $event"
              :selectedCondition="selectedCondition"
              :files="files"
              :userFiles="userFiles"
              :partnerFiles="partnerFiles"
              :privacyRoodieCheckboxColor="privacyRoodieCheckboxColor"
              :shouldSaveCheckboxColor="shouldSaveCheckboxColor"
              :forceAllPrivacies="forceAllPrivacies"
            ></component>
          </div>

          <!-- <ion-button
        class="ion-margin-top"
        fill="outline"
        @click="submitShare('nein')"
        >Nein</ion-button
      > -->

          <ion-button
            class="ion-margin-top"
            @click="submitShare('ja')"
            :disabled="
              !isPrivacyChecked ||
              (forceAllPrivacies && !isPrivacyRoodieChecked)
            "
            >Absenden</ion-button
          >
        </ion-grid>
      </div>
    </ion-content>
    <ion-modal
      :is-open="showPrivacyRoodieModal"
      :css-class="['c-autoheight-modal']"
      @didDismiss="showPrivacyRoodieModal = false"
    >
      <ion-page>
        <div class="ion-padding modal-content ion-text-center">
          <modal-close />
          <roodie fillOuter="#5E58BE" :expression="'happy'" />
          <div class="u-color-primary u-medium ion-margin-top">
            <p>
              Teilen Sie Ihren Roodie.Check im Vorfeld, damit die
              Arzt-/Kliniksuche gezielt für Sie starten kann. Wir bitten um
              Verständnis, dass
              {{
                routing.startsWith("ARAG Case Management")
                  ? "die ARAG Gesundheitsassistenten"
                  : routing
              }}
              ansonsten nochmals all diese Informationen zu Ihrem
              gesundheitlichen Anliegen von Ihnen erfragen
              {{
                routing.startsWith("ARAG Case Management") ? "müssen" : "muss"
              }}.
            </p>
            <div class="ion-margin-bottom">
              <img width="150" src="@/assets/img/header/icon_betterdoc.svg" />
            </div>
            <div>
              <ion-button fill="outline" @click="showPrivacyRoodieModal = false"
                >Zurück</ion-button
              >
              <ion-button
                fill="outline"
                @click="
                  submitShare('ja');
                  showPrivacyRoodieModal = false;
                "
                >Trotzdem weiter</ion-button
              >
            </div>
          </div>
        </div>
      </ion-page>
    </ion-modal>
    <ion-modal
      :is-open="showShouldSaveModal"
      :css-class="['c-autoheight-modal']"
      @didDismiss="showShouldSaveModal = false"
    >
      <ion-page>
        <div class="ion-padding modal-content ion-text-center">
          <modal-close />
          <roodie fillOuter="#5E58BE" :expression="'happy'" />
          <div class="u-color-primary u-medium ion-margin-top">
            <p class="u-bold ion-text-center">
              Um Ihnen helfen zu können, braucht es Ihre Einwilligung zur
              Weitergabe Ihrer personenbezogenen Gesundheitsdaten ganz oben.
            </p>
            <p class="ion-text-center">
              Speichern Sie andernfalls zumindest Ihren Roodie.Check, damit Sie
              ihn immer griffbereit haben.
            </p>
            <ion-item lines="none" class="ion-text-center u-inline-block">
              <ion-checkbox slot="start" v-model="shouldSave"> </ion-checkbox>
              <ion-label class="ion-text-wrap" color="primary">
                Ich möchte meinen Roodie.Check {{ filesText }}nur speichern und
                akzeptiere die
                <u class="u-bold"
                  ><a
                    href="#"
                    @click.prevent="
                      $browser.open({
                        url: 'https://www.roodie-health.com/arag/datenschutz',
                      })
                    "
                    >Datenschutzinformationen</a
                  ></u
                >.
                <a
                  href="#"
                  @click.prevent="openInfoModal(privacy3Text)"
                  style="text-decoration: none"
                  >MEHR</a
                >
              </ion-label>
            </ion-item>
            <div class="ion-margin-top">
              <ion-button
                fill="outline"
                @click="
                  submitShare('ja');
                  showShouldSaveModal = false;
                "
                >Weiter</ion-button
              >
            </div>
          </div>
        </div>
      </ion-page>
    </ion-modal>
  </ion-page>
</template>

<script>
import Roodie from "@lib/components/svg/Roodie";
import {
  IonButton,
  modalController,
  IonGrid,
  IonIcon,
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonModal,
  IonItem,
  IonLabel,
  IonCheckbox,
} from "@ionic/vue";
import { call, caretDown, caretUp, closeOutline } from "ionicons/icons";
import ModalClose from "@lib/components/ModalClose";
import PrivacyARAGCaseManagement from "@arag/components/PrivacyArag";
import PrivacyARAGCaseManagementZahn from "@arag/components/PrivacyAragZahn";
import PrivacyBetterDoc from "@arag/components/PrivacyBetterDoc";
import PrivacyZTK from "@arag/components/PrivacyZTK";
import axios from "@/plugins/axios";
import { saveCheck } from "@/api/roodiecheck";
import InfoModal from "@lib/components/InfoModal";

export default {
  components: {
    Roodie,
    IonButton,
    IonIcon,
    ModalClose,
    PrivacyARAGCaseManagement,
    PrivacyARAGCaseManagementZahn,
    PrivacyBetterDoc,
    PrivacyZTK,
    IonGrid,
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonModal,
    IonItem,
    IonLabel,
    IonCheckbox,
  },
  props: {
    routing: {
      required: true,
      type: String,
    },
    routingText: {
      required: true,
      type: String,
    },
    answers: {
      required: false,
      type: Array,
      default: () => {
        return [];
      },
    },
    selectedSentence: {
      required: false,
      type: String,
      default: "",
    },
    personalData: {
      required: false,
      type: Object,
      default: () => {
        return {};
      },
    },
    files: {
      required: false,
      type: Array,
      default: null,
    },
    userFiles: {
      required: false,
      type: Array,
      default: null,
    },
    partnerFiles: {
      required: false,
      type: Array,
      default: null,
    },
    shouldOpenFormContact: {
      required: false,
      type: Boolean,
      default: false,
    },
    selectedCondition: {
      required: false,
      type: Object,
      default: () => {
        return {};
      },
    },
    forceAllPrivacies: {
      type: Boolean,
      default: false,
    },
    caseId: {
      type: String,
      default: "",
    },
  },
  setup() {
    return { call, caretDown, caretUp, closeOutline };
  },
  data() {
    return {
      window: window,
      modalController: modalController,
      isCallTimeOpen: false,
      isPrivacyRoodieChecked: false,
      showPrivacyRoodieModal: false,
      privacyRoodieCheckboxColor: "primary",
      isPrivacyChecked: false,
      callDays: [],
      callTimes: [],
      privacy1Label: "",
      privacy2Label: "",
      shouldSave: false,
      showShouldSaveModal: false,
      shouldSaveCheckboxColor: "primary",
      apiSendCaseData: null,
    };
  },
  computed: {
    filesText() {
      let result = "";
      if (
        this.files.length ||
        this.userFiles.length ||
        this.partnerFiles.length
      ) {
        result = "samt (kieferorthopädischem) Behandlungsplan ";
      }
      return result;
    },
    privacy3Text() {
      return "<p>Die Angaben zu Ihren Symptomen bzw. Ihrem gesundheitlichen Anliegen werden in Ihrem Nutzerkonto im Menü unter Roodie.Safe gespeichert, damit Sie dort jederzeit auf sie zugreifen können und um bei Aktivierung unseres Benachrichtigungsservices bei Ihnen beispielhaft zu erfragen,  ob ein Termin zu Ihrer Zufriedenheit verlaufen ist, um uns nach Ihrem Wohlbefinden und/oder Genesungsfortschritt zu erkundigen, Sie an Termine zu erinnern und um Ihnen weiterführende Unterstützung von Gesundheitsdienstleistungspartnern zugänglich zu machen.</p><p>Es handelt sich dabei um personenbezogene Daten, die sich auf Ihre körperliche oder mentale Gesundheit, einschließlich der Erbringung von Gesundheitsdienstleistungen beziehen und aus denen Informationen über Ihren Gesundheitszustand hervorgehen. Rechtsgrundlage für die Verarbeitung dieser Daten ist Ihre Einwilligung gemäß Art 9 Abs 2 lit a DSGVO.</p>";
    },
  },
  methods: {
    async openInfoModal(text) {
      const modal = await modalController.create({
        component: InfoModal,
        cssClass: "my-custom-class",
        componentProps: {
          title: "Datenschutzbestimmungen",
          text: text,
        },
      });
      return modal.present();
    },
    changeCallDays(day) {
      if (this.callDays.includes(day)) {
        this.callDays.splice(this.callDays.indexOf(day), 1);
      } else {
        this.callDays.push(day);
      }
    },
    changeCallTimes(time) {
      if (this.callTimes.includes(time)) {
        this.callTimes.splice(this.callTimes.indexOf(time), 1);
      } else {
        this.callTimes.push(time);
      }
    },
    async submitShare(value) {
      // this.$parent.$emit("share");
      // if (
      //   !this.isPrivacyRoodieChecked &&
      //   !this.showPrivacyRoodieModal &&
      //   !this.showShouldSaveModal
      // ) {
      //   this.showPrivacyRoodieModal = true;
      //   this.privacyRoodieCheckboxColor = "danger";
      //   return;
      // }

      if (!this.isPrivacyRoodieChecked && !this.showShouldSaveModal) {
        this.showShouldSaveModal = true;
        return;
      }

      let response = null;
      if (this.forceAllPrivacies) {
        this.$store.commit("setMaxLoadingDuration", 120 * 1000);
        this.$store.commit("setShowLoading", true);
        response = await axios.post(
          "?Mode=General&Function=SendFullCaseToPartner",
          {
            Id: this.caseId,
            Privacy1Label: this.privacy1Label,
            Privacy2Label: this.privacy2Label,
          }
        );
        this.$store.commit("resetMaxLoadingDuration");
        if (response.data.Status !== "Success") {
          return;
        }
      } else {
        if (
          ["BetterDoc", "Quality Smile"].includes(this.routing) ||
          this.routing.startsWith("ARAG Case Management")
        ) {
          if (!this.apiSendCaseData) {
            this.$store.commit("setMaxLoadingDuration", 120 * 1000);
            this.$store.commit("setShowLoading", true);
            response = await saveCheck(this.answers, this.selectedSentence);
            this.$store.commit("resetMaxLoadingDuration");
            if (response.data.Status === "Success") {
              this.apiSendCaseData = new FormData();
              this.apiSendCaseData.append("Id", response.data.Result);
              this.apiSendCaseData.append("Routing", this.routing);
              this.apiSendCaseData.append("Msisdn", this.personalData.Msisdn);
              this.apiSendCaseData.append("Email", this.personalData.Email);
              this.apiSendCaseData.append("CallDays", this.callDays.join(", "));
              this.apiSendCaseData.append(
                "CallTimes",
                this.callTimes.join(", ")
              );
              this.apiSendCaseData.append(
                "ShareCheck",
                this.isPrivacyRoodieChecked
              );
              this.apiSendCaseData.append("Privacy1Label", this.privacy1Label);
              this.apiSendCaseData.append("Privacy2Label", this.privacy2Label);
              this.apiSendCaseData.append(
                "SaveCheck",
                this.shouldOpenFormContact || this.shouldSave
              );
              if (this.files) {
                for (const file of this.files) {
                  this.apiSendCaseData.append("Files[]", file, file.name);
                }
              }
              if (this.userFiles) {
                for (const file of this.userFiles) {
                  this.apiSendCaseData.append("UserFiles[]", file);
                }
              }
              if (this.partnerFiles) {
                for (const file of this.partnerFiles) {
                  this.apiSendCaseData.append("UserFiles[]", file);
                }
              }

              // Zahnvorsorge
              const dentalCare = this.answers.find((obj) => {
                return obj.id === "zf-16";
              });
              if (dentalCare) {
                this.apiSendCaseData.append("DentalCareDate", dentalCare.date);
              }

              // data.append("Files", this.files);
              this.$store.commit("setMaxLoadingDuration", 120 * 1000);
              this.$store.commit("setShowLoading", true);
              const hasApiSendCaseResult = await this.apiSendCase(
                this.apiSendCaseData
              );
              this.$store.commit("resetMaxLoadingDuration");
              if (!hasApiSendCaseResult) {
                return;
              }
            } else {
              return;
            }
          } else {
            this.$store.commit("setMaxLoadingDuration", 120 * 1000);
            this.$store.commit("setShowLoading", true);
            const hasApiSendCaseResult = await this.apiSendCase(
              this.apiSendCaseData
            );
            this.$store.commit("resetMaxLoadingDuration");
            if (!hasApiSendCaseResult) {
              return;
            }
          }
        }
      }
      this.modalController.dismiss({
        submit: value,
        checkId: response?.data?.Result,
        isCheckSaved: this.shouldSave || this.isPrivacyRoodieChecked,
      });
    },
    async apiSendCase(data) {
      const sendCaseResponse = await axios.post(
        "?Mode=General&Function=SendCase",
        data
      );
      if (
        sendCaseResponse.data.Status !== "Success" ||
        !sendCaseResponse.data.Result
      ) {
        return false;
      }
      this.$gtm.trackEvent({
        // event: null, // Event type [default = 'interaction'] (Optional)
        category: "Chat - Abschlüsse",
        action: "Geteilt",
        label: this.routing,
        value: 1,
        // noninteraction: false, // Optional
      });
      return true;
    },
  },
};
</script>

<style></style>
